export default __webpack_public_path__ + "static/media/countriesProject.ae03c35b.jpg";